/**
 * Platform display metadata — one source of truth for the social-network
 * name + glyph used across the UI (Connections tiles, the Stats tab's
 * per-network cards, etc.). Colours live in global.css as `.platform-<key>`
 * chips; this file is name + icon only.
 *
 * Keep keys aligned with the workers' platform registry + the
 * social_accounts.platform enum (migration 003).
 */
export const PLATFORM_META = {
  instagram: { name: 'Instagram', icon: '📷' },
  linkedin:  { name: 'LinkedIn',  icon: '💼' },
  x:         { name: 'X',         icon: '𝕏' },
  facebook:  { name: 'Facebook',  icon: '👍' },
  tiktok:    { name: 'TikTok',    icon: '🎵' },
  youtube:   { name: 'YouTube',   icon: '▶️' },
  threads:   { name: 'Threads',   icon: '@' },
  pinterest: { name: 'Pinterest', icon: '📌' },
};

/** Human name for a platform key, falling back to the raw key. */
export function platformName(platform) {
  return PLATFORM_META[platform]?.name || platform;
}

/** Glyph for a platform key, with a neutral link fallback. */
export function platformIcon(platform) {
  return PLATFORM_META[platform]?.icon || '🔗';
}
